import React from 'react';
import { useParams } from 'react-router-dom';
import { useTheme } from '../../contexts/ThemeContext';
import FinanceTab from '../../finance/FinanceTab';

const ExpenseTab = ({ voProvider }) => {
  const { theme } = useTheme();
  const { squadId } = useParams();

  if (!voProvider) {
    return (
      <div className={`${theme.card} rounded-2xl border ${theme.border} p-6 text-center`}>
        <p className={theme.textSecondary}>Loading...</p>
      </div>
    );
  }

  const entity   = voProvider.getGroup();
  const members  = voProvider.getMembers();
  const entityId = entity?.id || squadId;

  if (!entity) {
    return (
      <div className={`${theme.card} rounded-2xl border ${theme.border} p-6 text-center`}>
        <p className={theme.textSecondary}>Loading squad information...</p>
      </div>
    );
  }

  return (
    <FinanceTab
      entityId={entityId}
      entityType="Group"
      entity={entity}
      members={members}
    />
  );
};

export default ExpenseTab;
